import { render, staticRenderFns } from "./onSubFormRowDelete-editor.vue?vue&type=template&id=1a13f95e&scoped=true&"
import script from "./onSubFormRowDelete-editor.vue?vue&type=script&lang=js&"
export * from "./onSubFormRowDelete-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13f95e",
  null
  
)

export default component.exports